import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import asyncComponent from '../../util/asyncComponent';

const Routes = () =>
  <Switch>

<Route path={`/`}
     component={asyncComponent(() => import('./Evaluation/Evaluation'))} exact />

    <Route path={`/CollegeId`}
      component={asyncComponent(() => import('./College/College'))} />
    <Route path={`/UserLogin`}
      component={asyncComponent(() => import('./UserLogin/UserLogin'))} />

<Route path={`/BundleNo`}
      component={asyncComponent(() => import('./Bundle/BundleNo'))} />

<Route path={`/BundleKey`}
      component={asyncComponent(() => import('./BundleKey/BundleKey'))} />

<Route path={`/OmrCodes`}
      component={asyncComponent(() => import('./OmrCodes/OmrCodes'))} />

<Route path={`/MarksTable1`}
      component={asyncComponent(() => import('./MarkTable/MarksTable1'))} />

      
<Route path={`/ScriptsPDF`}
      component={asyncComponent(() => import('./ScriptsPDF/ScriptsPDF'))} />

<Route path={`/UserRegistration`}
      component={asyncComponent(() => import('./UserRegistration/UserRegistration'))} />

<Route path={`/UserEditRegistration`}
      component={asyncComponent(() => import('./UserEditRegistration/UserEditRegistration'))} />

    {/* <Route path={`/saved-cards`}
      component={asyncComponent(() => import('./SavedCardsAndComparisonsPage'))} />
        <Route
      path={`/cardholder-reviews`}
      component={asyncComponent(() =>
        import('./CardholderReview/CardholderReview.js')
      )}
        />
         <Route
      path={`/saved-offers`}
      component={asyncComponent(() =>
        import('./SavedOffers')
      )}
        />
          <Route
      path={`/referral`}
      component={asyncComponent(() =>
        import('./Referrals')
      )}
        />
                <Route
          path={'/cardholder-create-review'}
          component={asyncComponent(() =>
         import('./CardholderReview/AddCardholderReview.js')
      )}
                />
                 <Route
      path={`/credit-card-discounts`}
      component={asyncComponent(() =>
        import('./CreditCardDiscounts')
      )}
                />
    <Route component={asyncComponent(() =>  import('./DashboardPage'))}/> */}

  </Switch>;


export default withRouter(Routes);

